var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canEdit)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('account-profile',{attrs:{"expert":_vm.expert}})],1)],1):_c('information-list',{attrs:{"lists":_vm.lists}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7df435d9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/expert/Profile.vue
// module id = null
// module chunks = 